var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divloginmain"},[(_vm.type=='default')?_c('login',{ref:"login_default"}):_vm._e(),(_vm.type=='dynamic')?_c('logindynamic',{ref:"login_dynamic",staticClass:"loginMain",on:{"Login":_vm.Login,"Register":_vm.Register}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }